import { render, staticRenderFns } from "./gameuser-upload.vue?vue&type=template&id=088b8f86"
import script from "./gameuser-upload.vue?vue&type=script&lang=js"
export * from "./gameuser-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports